module.exports = __webpack_public_path__ + "img/code.0a0488a6.png";